<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      title=""
      left-text="返回首页"
      @click-left="onClickBack"
      :z-index="10"></van-nav-bar>
    <div class="view-bg">
      <div class="mian-bg">
        <div class="top-bg">
          <img
            class="icon-bg"
            src="../../assets/img/experience/experienceing_icon.png" />
          <div class="title">体验金正在体验中</div>
          <div class="title1">体验结束后，收益将帮您转入您的</div>
          <div class="title2">{{ fundOutType || "平台余额" }}</div>
        </div>
        <div class="process-bg">
          <div
            :class="index == finishIndex ? 'finish-item-bg' : 'item-bg'"
            v-for="(item, index) in dataSource"
            :key="index">
            <div class="left-bg">
              <div v-if="index != 0" class="line1"></div>
              <div class="dot"></div>
              <div
                :class="
                  index == 0
                    ? 'first-line'
                    : index == dataSource.length - 1
                    ? 'last-line'
                    : 'line'
                "></div>
            </div>
            <div class="right-bg">
              <div :class="index == 0 ? 'fitst-title' : 'title'">
                {{ item.title }}
              </div>
              <div class="content">{{ item.name }}</div>
              <div class="date">{{ item.time }}</div>
            </div>
          </div>
          <div class="notice-bg">(注：收益奖励发放以实际到账为准)</div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { experienceTimeLine } from "../../api/pay"
export default {
  data() {
    return {
      finishIndex: 0,
      fundOutType: "",
      dataSource: []
    }
  },
  mounted() {
    experienceTimeLine(this.$route.query.orderId)
      .then((data) => {
        this.fundOutType = data.fundOutType
        this.dataSource = data.entities || []
      })
      .catch((e) => {
        this.$toast(e.msg || e.message)
      })
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: "home" })
    }
  }
}
</script>
  <style lang="less" scoped>
.view-bg {
  min-height: calc(100vh - 45px);
  .mian-bg {
    .top-bg {
      background-color: white;
      padding: 15px;
      padding-bottom: 30px;
      text-align: center;
      font-size: 17px;
      .icon-bg {
        margin-top: 40px;
        margin-bottom: 15px;
        width: 80px;
        height: 80px;
        object-fit: fill;
        border-radius: 40px;
      }

      .title1 {
        color: #e29838;
        margin: 2px 0;
      }
      .title2 {
        color: rgb(253, 181, 10);
      }
    }
    .process-bg {
      background-color: white;
      margin-top: 10px;
      padding: 15px 0 0 0;
      padding-bottom: 20px;
      .finish-item-bg {
        color: rgb(48, 189, 17);
        .left-bg {
          .dot {
            background-color: rgb(48, 189, 17);
          }
          .line,
          .first-line,
          .line1 {
            background-color: rgb(48, 189, 17);
          }
          .last-line {
            background-color: transparent;
          }
        }
      }
      .item-bg {
        color: rgb(122, 122, 122);
        .left-bg {
          .dot {
            background-color: rgb(203, 203, 203);
          }
          .line,
          .first-line,
          .line1 {
            background-color: rgb(203, 203, 203);
          }
          .last-line {
            background-color: transparent;
          }
        }
      }
      .finish-item-bg,
      .item-bg {
        display: flex;
        .left-bg {
          width: 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .dot {
            width: 6px;
            height: 6px;
            border-radius: 3px;
          }
          .line,
          .first-line,
          .line1 {
            width: 2px;
          }
          .last-line,
          .line {
            height: calc(100% - 26px);
          }
          .first-line {
            height: calc(100% - 6px);
          }
          .line1 {
            height: 20px;
          }
        }
        .right-bg {
          width: calc(100% - 40px);
          .fitst-title {
            padding: 0 15px 5px 0;
          }
          .title {
            padding: 10px 15px 5px 0;
          }
          .date {
            padding-bottom: 5px;
            border-bottom: 1px solid rgb(203, 203, 203);
          }
        }
      }
      .notice-bg {
        margin-left: 40px;
        margin-top: 15px;
        color: rgb(122, 122, 122);
      }
    }
  }
}
</style>